import { useMemo } from 'react'
import { Flow } from '../types'
import { RenewableLicense } from './useRenewableLicense'

const SCHOOL_TYPES = ['school', 'schoolpro']

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function administersSchool(currentTeacher: any): boolean {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const administered = Object.values(
    currentTeacher?.adminLicenseInfos || {}
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ) as any[]
  return administered.some((li) => li && SCHOOL_TYPES.includes(li.licenseType))
}

/** Every set of plans this account is entitled to, whether or not it is showing them. */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function eligibleFlows(currentTeacher: any): Flow[] {
  if (!currentTeacher) return []
  const flows: Flow[] = []
  if (currentTeacher.isTeacher) flows.push('teacher')
  if (currentTeacher.isParent) flows.push('family')
  if (administersSchool(currentTeacher)) flows.push('school')
  return flows.length ? flows : ['teacher']
}

export default function useAccountFlows(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  currentTeacher: any,
  cameFrom: RenewableLicense | null = null
): Flow[] {
  return useMemo(() => {
    if (!currentTeacher) return []
    const eligible = eligibleFlows(currentTeacher)

    if (cameFrom && eligible.includes(cameFrom.flow)) return [cameFrom.flow]
    // An account that administers a school IS a school: those are its plans. Everyone else gets
    // their role's, and never the school ones — new schools go through sales.
    if (administersSchool(currentTeacher)) return ['school']
    return eligible.filter((flow) => flow !== 'school')
  }, [currentTeacher, cameFrom])
}
